module.exports = __webpack_public_path__ + "static/img/arrow-up.ed647d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow-up.png
// module id = dT4E
// module chunks = 0